<template>
  <div class="deviceAnalysisNew section tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading">
    <div class="section-header">
      <div>
        <el-popover popper-class="paramBox" placement="bottom">
          <!-- 参数 -->
          <div  slot="reference">
            <span style="color: #fff;font-size: 14px;font-weight: bold;display: inline-block;padding: 3px 4px 0 15px;" class="eb-inputwrapper">{{$t('device.parameter')}}</span>
            <el-input
              class="inputCss"
              style="width:200px;margin-right: 15px;caret-color:transparent;"
              :placeholder="optionsTitle"
            >
              <i slot="suffix" class="iconfont icon-a-mingchengxiaojiantouxia2"></i>
            </el-input>
          </div>
          <!-- 参数下拉复选框 -->
          <div class="checkboxlist" :class="this.$lang.currentLang == 'zh_CN'?'checkboxlistZh':'checkboxlistUs'">
            <el-checkbox-group @change="checkboxParam" v-model="optionsData1" >
              <el-checkbox 
                class="check"
                :key="item.e0"
                v-for="item in optionsData"
                :label="item.e0"
                :title="item.e1 + '(' + item.e3 + ')'"
                style="display:flex;flex-direction: row-reverse;justify-content:space-between;width:100%;margin-right:0px;padding: 2px 0;" 
              >
                {{item.e1 + "(" + item.e3 + ")"}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-popover>
      </div>
      <div class="tool">
        <div class="datePreNext">
          <span class="date-icon"></span>
          <!-- 上一天 -->
          <span class="date-btn date-pre" @click="toPreDay"></span>
          <!-- 日期选择器 -->
          <el-date-picker v-model="selectedDate" :editable="false" :clearable="false" popper-class="select-date"
                      :picker-options="pickerDayOptions" ref="dateDay"></el-date-picker>
          <!-- 下一天 -->
          <span class="date-btn date-next" @click="toNextDay"></span>
        </div>
      </div>
    </div>
    <div class="section-chart">
            <echart-line :parmasId="parmasId" :category="chartData.category" :data="chartData.data" :unit="chartData.unit" unitX="H"></echart-line>
    </div>
  </div>
</template>
<script>
import echartLine from "@/components/echartsNew/line3";
import { mapGetters,mapState } from 'vuex';
import { i18n } from '@/i18n';
export default {
  components: {
    echartLine
  },
  props: {
    devData: {
      type: Object
    }
  },
  data () {
    return {
      analysisFlag:JSON.parse(sessionStorage.getItem('vcodes')||[]).some(item => item === "08"),
      optionsData:[],//复选框数据
      optionsData1:[],//勾选值
      optionsTitle:"",//勾选提示
      parmasId:true,
      selectedDate: new Date(), // 所选时间
      options: {}, // 可选参数列表
      selectedOption: null, // 所选参数
      chartData: {
        category: [], // 数据模块
        data: [],
        unit: null,
        isArea: true
      }, // 图表数据
      isLoading: false, // 正在加载数据
      pickerDayOptions: {
        shortcuts: [{
          text: i18n.t('device.cur_today') + "：" +
            String(new Date().getFullYear()) + '/' +
            String(new Date().getMonth() + 1) + '/' +
            String(new Date().getDate())
          ,
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }],
        disabledDate(time) {
          return time.getTime() > Date.now(); // 设置选择今天以及今天之前的日期
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo',
      chartStatus: 'getChartStatus'
    }),
     ...mapState({
      method: state => state.user.method,
      isMicroService: state => state.user.isMicroService,
      code: state => state.user.code,
      resData: state => state.user.resData
    })
  },
  watch: {
    deviceInfo: {
      handler () {
        // 切换设备清除数据
        this.optionsData=[]
        this.optionsData1=[]
        this.queryFields()
      },
      deep: true
    },
    selectedOption () {
      this.queryData()
    },
    optionsData1 () {
      if (this.$lang.currentLang == 'zh_CN') {
        this.optionsTitle=this.$t("device.optionTitle") + this.optionsData1.length + this.$t("device.optionTitle1")
      }else{
        this.optionsTitle=this.optionsData1.length +" " + this.$t("device.optionTitle")
      }
    },
    selectedDate () {
      this.queryData()
    }
  },
  methods: {
    // 勾选参数数量判断
    checkboxParam(value){
      let aaa=[]
      this.optionsData1.forEach((item)=>{
        this.optionsData.forEach((value)=>{
          if (item==value.e0) {
            aaa.push(value.e3)
          }
        })
      })
      let bbb=new Set(aaa).size
      if (bbb>2&&!this.analysisFlag) {
        this.optionsData1.pop()
        this.$message.error(this.$t("device.optionTitle3"));
        return
      }
      if (this.optionsData1.length>4&&!this.analysisFlag) {
        this.optionsData1.pop()
        this.$message.error(this.$t("device.optionTitle2"));
        return
      }else if(this.optionsData1.length==0){
        this.optionsData1.push(this.optionsData[0].e0)
      }else if(this.optionsData1.length>12&&this.analysisFlag){ 
        this.optionsData1.pop()
        this.$message.error(this.$t("device.optionTitle4"));
        return
      }
      let optionSessionStorage={
        code:this.deviceInfo.devcode,
        option:this.optionsData1,
      }
      sessionStorage.setItem(this.deviceInfo.devcode,JSON.stringify(optionSessionStorage))
      this.queryData()
    },
    // 切换上一天
    toPreDay () {
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let preDay = this.$tool.getYestoday(aimTime);
      // this.selectedDate = preDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(preDay)) {
        const [y, m, d] = preDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = preDay;
      }
    },
    // 切换下一天
    toNextDay () {
      let dayValue= new Date(this.$refs.dateDay.value)
      if (dayValue>Date.now()-8.64e7) return this.$message.warning(this.$t("device.noDate"));
      let aimTime = this.$filter.formatDate(this.$refs.dateDay.value, "yyyy-MM-dd");
      let nextDay = this.$tool.getNextday(aimTime);
      // this.selectedDate = nextDay;
      if (/^\d{4}-\d{2}-\d{2}$/.test(nextDay)) {
        const [y, m, d] = nextDay.split('-');
        this.selectedDate = new Date(Number(y), Number(m) - 1, Number(d));
      } else {
        this.selectedDate = nextDay;
      }
    },
    // 获取所有参数
    queryFields () {
     let param = {
        devcode: this.deviceInfo.devcode,
        pn: this.deviceInfo.pn,
        sn: this.deviceInfo.sn,
        devaddr: this.deviceInfo.devaddr,
        lang: this.$lang.currentLang
      }
      const sessionStorageData=JSON.parse(sessionStorage.getItem(this.deviceInfo.devcode));
      let url = this.isMicroService ? "/ppe/api/auth/web/queryDeviceChartField" : "queryDeviceChartField";
      return  this.$request[this.method](url, param).then(res=>{
        if (!res[this.code]) {
          if (sessionStorageData) {
            this.optionsData1=sessionStorageData.option
          }else{
            this.optionsData1.push(res[this.resData][0].e0)
          }
          this.optionsData=res[this.resData]
          this.queryData()
        }
      })
    },
// 获取图表数据   改（#13696）
    async queryData(){
      this.chartData={
        category: [], // 数据模块
        data: [],
        unit: null,
        isArea: true
      }
      this.isLoading = true
      let date = this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd')
      for(let i = 0; i < this.optionsData1.length; i++){
        let param = {
          pn: this.deviceInfo.pn,
          devcode: this.deviceInfo.devcode,
          sn: this.deviceInfo.sn,
          devaddr: this.deviceInfo.devaddr,
          field: this.optionsData1[i],
          precision: 5,
          sdate: date + ' 00:00:00',
          edate: date + ' 23:59:59',
          i18n: this.$lang.currentLang,
          chartStatus: this.chartStatus.chartStatus,
        }
        const res = await this.$request.get('queryDeviceChartFieldDetailData', param).catch(()=>{
          this.chartData={
            category: [], // 数据模块
            data: [],
            unit: null,
            isArea: true
          }
          this.isLoading = false
        })
          let chartData = {
            category: [],
            data: [{
              name: "",
              value: []
            }],
          }
          this.optionsData.forEach(value=>{
            if (this.optionsData1[i]==value.e0) {
              chartData.data[0].name=value.e1 + "(" + value.e3 + ")"
            }
          })

          if (!res.err) {
            res.dat.forEach(item => {
              chartData.category.push(item.key)
              if (item.val - 0==Number) {
                chartData.data[0].value.push(parseFloat((item.val - 0).toFixed(3)))
              }else{
                chartData.data[0].value.push((item.val - 0).toFixed(3))
              }
            })
          } else {
            chartData.category.push(this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 00:00:00', this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 23:59:59')
            chartData.data[0].value.push('0.00', '0.00')
          }
          this.chartData.category=chartData.category
          this.chartData.data.push(chartData.data[0])
          this.isLoading = false
          
      }
      const res = new Map()
      this.chartData.data =  this.chartData.data.filter((arr) => !res.has(arr.name) && res.set(arr.name, 1))
      // console.log(this.chartData,'this.chartData');
    },
    // 获取参数图表数据   原
    // queryData(){
    //   this.chartData={
    //     category: [], // 数据模块
    //     data: [],
    //     unit: null,
    //     isArea: true
    //   }
    //   this.isLoading = true
    //   let date = this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd')
    //   this.optionsData1.forEach((item,index)=>{
    //     let param = {
    //       pn: this.deviceInfo.pn,
    //       devcode: this.deviceInfo.devcode,
    //       sn: this.deviceInfo.sn,
    //       devaddr: this.deviceInfo.devaddr,
    //       field: item,
    //       precision: 5,
    //       sdate: date + ' 00:00:00',
    //       edate: date + ' 23:59:59',
    //       i18n: this.$lang.currentLang,
    //       chartStatus: this.chartStatus.chartStatus,
    //     }
    //     this.$request.get('queryDeviceChartFieldDetailData', param).then(res=>{
    //       let chartData = {
    //         category: [],
    //         data: [{
    //           name: "",
    //           value: []
    //         }],
    //       }
    //       this.optionsData.forEach(value=>{
    //         if (item==value.e0) {
    //           chartData.data[0].name=value.e1 + "(" + value.e3 + ")"
    //         }
    //       })

    //       if (!res.err) {
    //         res.dat.forEach(item => {
    //           chartData.category.push(item.key)
    //           if (item.val - 0==Number) {
    //             chartData.data[0].value.push(parseFloat((item.val - 0).toFixed(3)))
    //           }else{
    //             chartData.data[0].value.push((item.val - 0).toFixed(3))
    //           }
    //         })
    //       } else {
    //         chartData.category.push(this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 00:00:00', this.$filter.formatDate(this.selectedDate, 'yyyy-MM-dd') + ' 23:59:59')
    //         chartData.data[0].value.push('0.00', '0.00')
    //       }
    //       this.chartData.category=chartData.category
    //       this.chartData.data.push(chartData.data[0])
    //       this.isLoading = false
    //     })
    //     .catch(()=>{
    //       this.chartData={
    //         category: [], // 数据模块
    //         data: [],
    //         unit: null,
    //         isArea: true
    //       }
    //       this.isLoading = false
    //     })
    //   })
    // },
  },
  created () {
    this.queryFields()
  },
}
</script>
<style lang="less">
.paramBox{
  background-color: #222d35;
  border: none;
  margin-left: 80px;
  .checkboxlist{
    color: #fff;
    max-height: 200px;
    overflow: auto;
    padding-right: 5px;
    .check{
      &:hover {
        background-color: @primaryColorTransparency30;
      }
    }
    .el-checkbox__label {
      font-size: 16px;
      line-height: 16px;
      padding: 2px 0;
      color: #fff;
      width: calc(100% - 30px);
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .el-checkbox__input .el-checkbox__inner {
      width: 20px;
      height: 20px;
      border: 1px solid  #1890ff;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: @primaryTextColor;
    }

    .el-checkbox .el-checkbox__input .el-checkbox__inner::after {
      top: 3px;
      left: 7px;
    }

    .el-checkbox .el-checkbox__input.is-checked+.el-checkbox__label {
      color: #fff;
    }
  }
  .checkboxlistZh{
    width: 250px
  }
  .checkboxlistUs{
    width: 350px
  }
}
</style>
<style lang="less" scoped>
@import url('../../../../assets/css/mixin.less');

.deviceAnalysisNew {
  display: flex;
  flex-direction: column;
  background-color: rgb(34, 45, 53);

  .section-header {
    // margin-top:20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-bottom: 1px solid #7B8395;
    .inputCss{
      /deep/.el-input__inner{
        cursor: pointer !important;
      }
      .el-input__suffix i {
          font-size: 14px;
      }
      .el-input__suffix i::before {
        display: inline-block;
        position: absolute;
        top: 10px;
        right: -2px;
        height: 20px;
        width: 20px;
      }
    }
    /deep/.el-input__inner{
      background-color: #222d35;
      border: none;
    }
    /deep/.el-date-editor.el-input .el-input__prefix {
      right: auto;
      left: 16px;
      font-size: 16px;
      color: #00FEBB;
    }
    /deep/.el-date-editor.el-input .el-input__inner {
      height: 46px;
      padding-left: 52px;
      background: transparent;
      color: #ffffff;
      border: none;
      border-radius: 0px;
      // border-left: 1px solid #7B8395;
      // border-right: 1px solid #7B8395;
    }
    /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      right: -2px;
      height: 20px;
      width: 20px;
      background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }
    .tool {
      /deep/.el-date-editor.el-input .el-input__prefix {
        right: auto;
        left: 16px;
        font-size: 16px;
        color: #00FEBB;
      }

      /deep/.el-date-editor.el-input .el-input__inner {
        height: 46px;
        padding-left: 52px;
        background: transparent;
        color: #ffffff;
        border: none;
        border-radius: 0px;
      }

      /deep/.el-date-editor.el-input .el-input__suffix .el-input__icon:after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        right: -2px;
        height: 20px;
        width: 20px;
        background: url(../../../../assets/img/general/Icon_Down_Border.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }

      // 时间图标
      /deep/.el-icon-date:before {
        content: "";
        display: inline-block;
        position: absolute;
        top: 12px;
        left: 0px;
        height: 24px;
        width: 24px;
        background: url(../../../../assets/img/general/Icon_Calendar.png) no-repeat;
        background-size: 100%;
        background-position: center;
      }

      // 日期盒子
      .datePreNext {
        padding: 0px 16px;
        border-left: 1px solid #7B8395;
        border-right: 1px solid #7B8395;

        /deep/.datepicker {
          margin: 0px;
        }

        /deep/.el-date-editor {
          margin-right: 16px;
        }

        /deep/.el-date-editor.el-input {
          width: 150px;
        }

        /deep/.el-date-editor.el-input .el-input__inner {
          padding: 0px;
          text-align: center;
        }
        /deep/.el-input__prefix {
          display: none;
        }

        /deep/.el-input__suffix {
          top: 2px;
          right: 16px;
        }

        .date-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../../../assets/img/general/Icon_Calendar.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 16px;
        }

        .date-pre {
          background: url(../../../../assets/img/general/Chart_Date_Pre.png);
        }

        .date-next {
          background: url(../../../../assets/img/general/Chart_Date_Next.png);
        }

        .date-btn {
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          height: 16px;
          width: 16px;
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
        }
      }
    }
  }

  .section-chart {
    flex: 1;
    padding: 0 10px;
  }
}

.section {
  border: none;
  box-shadow: none;
  padding: 0;
}

.tableloding {

  // 加载数据时遮罩
  /deep/.el-loading-mask {
    background-color: rgb(34, 45, 53, .5);
  }

  /deep/.el-loading-spinner i {
    color: @primaryTextColor;
  }
}</style>